export default __webpack_public_path__ + "static/destiny2_div-175ee5c366e900f96ec6b362db88e785.avif";